import { Page } from '@/shared/models/page.model';

/** Filtro de período da consulta de reuniões (valor enviado ao backend). */
export enum EComissaoReuniaoTipoPeriodoFiltro {
    TODOS = 'TODOS',
    POR_PERIODO = 'POR_PERIODO',
    CODIGO_REUNIAO = 'CODIGO_REUNIAO',
    PROXIMOS_15_DIAS = 'PROXIMOS_15_DIAS',
    PROXIMOS_30_DIAS = 'PROXIMOS_30_DIAS'
}

/** Filtro de pendência de convocação/confirmação. */
export enum EComissaoReuniaoTipoConvocacaoFiltro {
    TODOS = 'TODOS',
    CONVOCACOES_PENDENTES = 'CONVOCACOES_PENDENTES',
    CONFIRMACOES_PENDENTES = 'CONFIRMACOES_PENDENTES'
}

/** Filtro de marcação de importância da ata. */
export enum EComissaoReuniaoMarcacaoAtaFiltro {
    TODAS = 'TODAS',
    NAO_IMPORTANTE = 'NAO_IMPORTANTE',
    IMPORTANTE = 'IMPORTANTE'
}

export interface ComissaoReuniaoFiltroRequest {
    tipoPeriodo?: EComissaoReuniaoTipoPeriodoFiltro;
    dataInicioReuniao?: string;
    dataFimReuniao?: string;
    /** UF da comissão (CCT_COMISSAO_CT.UF_SG_UF_EE); nulo = todas as UFs. */
    ufSgUf?: string;
    codigoReuniao?: number;
    idEstruturaOrganizacional?: number;
    idStatusReuniao?: number;
    excluirStatusReuniaoExcluida?: boolean;
    idLocalReuniao?: number;
    tipoConvocacao?: EComissaoReuniaoTipoConvocacaoFiltro;
    idTipoComissaoCt?: number;
    idStatusAta?: number;
    marcacaoAta?: EComissaoReuniaoMarcacaoAtaFiltro;
    idSolicitanteAssistente?: number;
    ufSolicitanteAssistente?: string;
    idMembroConvidado?: number;
    ufMembroConvidado?: string;
}

export interface ComissaoReuniaoResponse {
    idReuniao?: number;
    dhAgendamento?: string;
    dhFimReuniao?: string;
    dhInicioReuniao?: string;
    dtUltimaAlteracao?: string;
    idEstruturaOrganizacional?: number;
    dsEstruturaOrganizacional?: string;
    idLocalReuniao?: number;
    dsLocalReuniao?: string;
    idStatusReuniao?: number;
    dsStatusReuniao?: string;
    idSolicitanteAlteracao?: number;
    sgUfSolicitanteAlteracao?: string;
    nmSolicitanteAlteracao?: string;
    idSolicitanteCoordenador?: number;
    sgUfCoordenador?: string;
    nmSolicitanteCoordenador?: string;
    idSolicitanteAssistente?: number;
    ufSolicitanteAssistente?: string;
    nmSolicitanteAssistente?: string;
    idTipoComissaoCt?: number;
    inImportante?: string;
    dsImportante?: string;
    idStatusAta?: number;
    dsStatusAta?: string;
    idProximoStatus?: number;
    idStatusAnterior?: number;
    dsStatusAtaProximo?: string;
    dsStatusAtaAnterior?: string;
    totalConvocacoes?: number;
    totalConfirmacoes?: number;
    totalMembros?: number;
    totalAtos?: number;
    idProtocolo?: number;
    numeroProtocolo?: string;
    possuiAtividades?: number;
    dsModalidade?: string;
    inModalidade?: string;
    inVisivelPortal?: string;
    dsVisivelPortal?: string;
}

export interface ComissaoStatusAtaResponse {
    idStatusAta?: number;
    dsStatusAta?: string;
}

export interface ComissaoLocalReuniaoResponse {
    idLocalReuniao?: number;
    dsLocalReuniao?: string;
    inInternoExterno?: string;
}

export interface ComissaoEstruturaFiltroResponse {
    idEoSuperior?: number;
    idEstruturaOrganizacional?: number;
    dsEstruturaOrganizacional?: string;
    idTipoComissaoCt?: number;
    ativo?: number;
}

export interface ComissaoTipoComissaoResponse {
    idTipoComissaoCt?: number;
    dsTipoComissaoCt?: string;
}

export interface ComissaoAssistenteResponse {
    nmSolicitante?: string;
    ufSgUf?: string;
    idSolicitante?: number;
    codigo?: string;
}

/** Foto do assistente em data-URI base64 — ausente quando não há foto em WEB_USUARIO nem em IMAGEM. */
export interface ComissaoAssistenteFotoResponse {
    foto?: string | null;
}

export interface ComissaoReuniaoDocumentoHtmlResponse {
    idReuniao?: number;
    txDocumentoHtml?: string;
    etag?: string;
}

export interface ComissaoAtaModeloResponse {
    idModeloAta?: number;
    dsModeloAta?: string;
}

export interface ComissaoAtaModeloDocumentoResponse {
    idModeloAta?: number;
    dsModeloAta?: string;
    txDocumentoHtml?: string;
}

export interface ComissaoAtaInserirModeloRequest {
    idModeloAta: number;
    posicao?: 'INICIO' | 'FIM' | 'SUBSTITUIR';
}

export interface ComissaoAtaAutosaveConfigResponse {
    habilitado?: boolean;
    intervaloSegundos?: number;
}

export interface ComissaoAtaProtocoloResponse {
    idReuniao?: number;
    idProtocolo?: number;
    numeroProtocolo?: string;
}

export interface ComissaoReuniaoMembroResponse {
    nmSolicitante?: string;
    idSolicitante?: number;
    ufSgUf?: string;
    inPresenca?: string;
    idReuniao?: number;
    inFuncao?: string;
    tipo?: number;
}

export interface ComissaoAtaConvidadoResponse {
    nmSolicitante?: string;
    idSolicitante?: number;
    ufSgUf?: string;
    idReuniao?: number;
    inPresenca?: string;
    inFuncao?: string;
}

export interface ComissaoAtaSalvarRequest {
    txDocumentoHtml?: string;
    inImportante?: string;
    dsImportante?: string;
    etag?: string;
}

export interface ComissaoAtaSalvarResponse {
    etag?: string;
}

export interface ComissaoAtaImportanteRequest {
    inImportante?: string;
    dsImportante?: string;
}

export interface ComissaoAtaStatusRequest {
    idStatusAta: number;
}

export interface ComissaoAtaParticipanteRequest {
    idSolicitante: number;
    ufSgUf: string;
    inPresenca?: string;
    inFuncao?: string;
}

export interface ComissaoAtaConvidadoRequest {
    idSolicitante: number;
    ufSgUf: string;
}

export interface ComissaoReuniaoAssistenteRequest {
    idSolicitanteAssistente?: number | null;
    ufSolicitanteAssistente?: string | null;
}

export interface ComissaoReuniaoSalvarRequest {
    dhInicioReuniao: string;
    dhFimReuniao: string;
    idLocalReuniao: number;
    idEstruturaOrganizacional: number;
    idTipoComissaoCt: number;
    idSolicitanteAssistente?: number | null;
    ufSolicitanteAssistente?: string | null;
    idSolicitanteCoordenador?: number | null;
    sgUfCoordenador?: string | null;
    inModalidade: string;
    inVisivelPortal: string;
}

export interface ComissaoReuniaoSalvarResponse {
    idReuniao?: number;
}

export interface ComissaoConvocacaoContextoResponse {
    idReuniao?: number;
    idStatusReuniao?: number;
    dtConvocacao?: string;
    dtAtoConcessao?: string;
    dsObservacao?: string;
}

export interface ComissaoConvocacaoParticipanteResponse {
    nmSolicitante?: string;
    idMembroComissao?: number;
    ufMembroComissao?: string;
    idSolicitante?: number | null;
    ufSgUf?: string | null;
    dtConfirmacao?: string | null;
    idMeioConfirmacao?: number | null;
    idReuniao?: number | null;
    inAtoConcessao?: string | null;
    inConfirmacao?: string | null;
    dsMeioConfirmacao?: string | null;
    idParticipacao?: number | null;
    inPresenca?: string | null;
    dsPresenca?: string | null;
    inEmissaoPassagem?: string | null;
    inStatusEnvioEmailOk?: string | null;
    inStatusEnvioEmailErro?: string | null;
    nmEmail?: string | null;
    telefone?: string | null;
    telefones?: string | null;
    dhEnvioEmail?: string | null;
}

export interface ComissaoConvocacaoGerenciarResponse {
    contexto?: ComissaoConvocacaoContextoResponse;
    participantes?: ComissaoConvocacaoParticipanteResponse[];
}

export interface ComissaoConvocacaoContextoRequest {
    dtConvocacao?: string | null;
    dtAtoConcessao?: string | null;
    dsObservacao?: string | null;
}

export interface ComissaoConvocacaoParticipanteRequest {
    idSolicitante: number;
    ufSgUf: string;
    inAtoConcessao?: string | null;
    inEmissaoPassagem?: string | null;
    inConfirmacao?: string | null;
    inPresenca?: string | null;
    idMeioConfirmacao?: number | null;
}

export interface ComissaoConvocacaoMarcarTodosRequest {
    inAtoConcessao: string;
}

export interface ComissaoConvocacaoEmailDestinatarioRequest {
    idSolicitante: number;
    ufSgUf: string;
    nmEmail?: string | null;
}

export interface ComissaoConvocacaoEmailRequest {
    enviarTodos?: boolean;
    destinatarios?: ComissaoConvocacaoEmailDestinatarioRequest[];
}

export interface ComissaoConvocacaoEmailParticipanteResponse {
    idSolicitante?: number;
    ufSgUf?: string;
    nmSolicitante?: string;
    nmEmail?: string;
    inStatusEnvioEmail?: string;
    dsStatusEnvio?: string;
    dhEnvioEmail?: string;
}

export interface ComissaoConvocacaoEmailEnvioResponse {
    idReuniao?: number;
    totalProcessados?: number;
    totalEnviados?: number;
    totalErros?: number;
    participantes?: ComissaoConvocacaoEmailParticipanteResponse[];
}

export interface ComissaoAtaInicioTextoResponse {
    idReuniao?: number;
    textoInicioAta?: string;
}

export interface ComissaoAtaFinalizacaoTextoResponse {
    idReuniao?: number;
    textoFinalizacaoAta?: string;
}

export type ComissaoReuniaoPageResponse = Page<ComissaoReuniaoResponse>;

export interface ComissaoReuniaoDashboardSummaryResponse {
    totalAgendadas?: number;
    dataProximaReuniao?: string;
    codigoProximaReuniao?: number;
    dataUltimaReuniao?: string;
    codigoUltimaReuniao?: number;
}
